import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { App } from '@df/core/app';
import { Status } from '@df/core/status';
import { SocialService } from '@df/ui/social/social.service';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { ActionComponent } from '../api/action.component';
import { ResultComponent } from '../resut/result.component';

@Component({
    selector: 'social-login',
    templateUrl: './social-login.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [ActionComponent, NgClass, ResultComponent, TranslationModule],
    styleUrls: ['./social-login.scss']
})
export class SocialLoginComponent {
    status = new Status();

    constructor(
        private app: App,
        private socialService: SocialService
    ) {}
    get socialLogin() {
        return Object.entries(this.app.data.connect).map(([k, v]) => ({
            serviceName: k,
            valid: v,
            image: '/assets/images/login-' + k + '.svg'
        }));
    }
    login(link: string): void {
        this.socialService.login(this.status, link);
    }
}
